import { Link, usePage } from '@inertiajs/react'
import { cn } from '@/lib/utils'
import { CTAButton } from './CTAButton'
import { MobileNav } from './MobileNav'
import { mainNavItems } from './navigation-config'

export function Header() {
  const { url } = usePage()
  // Inertia's usePage().url is path+query; strip the query string so active-link
  // matching works on filtered routes like /bikes?category=family.
  const currentPath = url.split('?')[0]

  return (
    <header
      data-testid="layout-header"
      className="sticky top-0 z-40 w-full border-b backdrop-blur-[10px] backdrop-saturate-[140%] bg-background/92 supports-[backdrop-filter]:bg-background/80"
    >
      <div className="mx-auto flex h-16 max-w-[96rem] items-center justify-between px-4 sm:px-6 lg:px-8">
        {/* Logo + wordmark — restored from old site (cargo-bike-with-mountains
            mark, full "Front Range Cargo Bikes" wordmark). Logo asset is the
            same file used on the previous Next.js site. */}
        <Link href="/" aria-label="Front Range Cargo Bikes — home" className="flex items-center gap-3">
          <img
            src="/images/logo-final.png"
            alt="Front Range Cargo Bikes"
            className="h-10 w-auto shrink-0"
          />
          <div className="hidden sm:block leading-tight">
            <div className="font-semibold text-base text-primary leading-none">
              Front Range Cargo Bikes
            </div>
            <div className="mt-0.5 text-[11px] tracking-[0.14em] uppercase text-muted-foreground font-semibold">
              Boulder
            </div>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-6" aria-label="Main">
          {mainNavItems.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              aria-current={currentPath === item.href ? 'page' : undefined}
              className={cn(
                'text-sm font-medium transition-colors hover:text-primary border-b-2 pb-0.5',
                currentPath === item.href
                  ? 'text-primary border-accent'
                  : 'text-foreground border-transparent'
              )}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        {/* Desktop CTA + Mobile Nav */}
        <div className="flex items-center gap-4">
          <CTAButton href="/book" size="sm" className="hidden sm:inline-flex">
            Book a free test ride
          </CTAButton>
          <MobileNav />
        </div>
      </div>
    </header>
  )
}
